
import api from '@/api/proxyWeb/listes'

export default {

    getAll({ commit }) {

        return api.getAll()
            .then( listes => commit('setListes', listes) )
    }
}